export default "__VITE_ASSET__BAyI_Mz8__"